export const ru = {
    'add-minus-keywords-pack-success': 'Набор успешно создан'
};
